export default __webpack_public_path__ + "080b04c343ee258098e07ba9a14ca764.png";